import './index.css';
import mainBanner from '../../assets/img/jpg/main_banner05.jpg';
import hanleyImg from '../../assets/img/png/hanley2.png';
import { Header } from '../../components/header/Header';
import { Link } from 'react-router-dom';
import { useLang } from '../../context/LangContext';
import { Footer } from '../../components/footer/Footer';

export function Index() {
    const { lang } = useLang();

    return (
        <>
            <Header />
            <section className='main_section'>
                <h1>
                    { lang === "en" ? "It's time to learn how to be successful" : "Es hora de aprender a ser exitoso"}
                    <br />
                    <span>
                        { lang === "en" ? "IN COACHING" : "EN COACHING"}
                        
                    </span>
                </h1>
                <Link to={"/courses"}>
                    { lang === "en" ? "ALL ACADEMIES" : "TODAS LAS ACADEMIAS"}
                    
                </Link>
                <img src={hanleyImg} className='hanley' alt='' />
                <img src={mainBanner} className='bk' alt='' />
            </section>
            <section className='future_section'>
                <h2>
                    { lang === "en" ? "YOUR FUTURE" : "TÚ FUTURO"}
                    <br />
                    <span>
                        { lang === "en" ? "STARTS TODAY" : "EMPIEZA HOY"}
                    </span>
                </h2>
                <p>
                { lang === "en" ? (
                            <>
                                "In every moment, each of us has the option to transform everything that is possible in the next step of our lives"
                            </>
                        ) : (
                            <>
                                “En todo momento, cada uno de nosotros tiene la opción de transformar todo
                                lo que es posible en el próximo momento de nuestras vidas”
                            </>
                        )}
                    
                </p>
            </section>
            <section className='whois_john_section'>
                <div className='media'>
                    <iframe src="https://www.youtube.com/embed/z9s66qClF1Q" title="About John Hanley" frameBorder="0"></iframe>
                </div>
                <div className='content'>
                    <h2>
                        { lang === "en" ? "Why Study at " : "¿Por qué Estudiar en la Academia" }
                        <br />
                        <span>
                        { lang === "en" ? "John Hanley PhD Academy?" : "John Hanley PhD?" }
                        
                            
                        </span>
                         
                    </h2>
                    <p>
                        { lang === "en" ? (
                            <>
                                The John Hanley PhD Trainers Academy is distinguished by 50 years of experience and learning, teaching us to create contexts, learn to manage what has not been manageable up to this point, and this would be the important question for you, what you are committed to today that is not available to you?
                            </>
                        ) : (
                            <>
                                La Academia de Entrenadores de John Hanley PhD se distingue por 50 años de experiencia y aprendizaje, enseñándonos a crear contextos y aprender a manejar lo que hasta este momento no ha sido manejable. Esta sería la pregunta importante para ti, ¿qué con lo que tú estás comprometido hoy no está disponible para ti?
                            </>
                        )}
                    </p>
                </div>
            </section>

            <Footer />
        </>
    );
}